(function($){
    $(function () {
        const inlineSVG = require('inline-svg');
        inlineSVG.init({
            svgSelector: 'img.svg'
        }, function () {
           $(document).trigger('SVG-inlined');
        });
    });
})(jQuery);
